import { render, staticRenderFns } from "./Isoprocess.vue?vue&type=template&id=22376b34"
import script from "./Isoprocess.vue?vue&type=script&lang=js"
export * from "./Isoprocess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports